import { cnpj } from 'cpf-cnpj-validator';

export const validateCnpj = (cnpjInput: string): boolean => {
  return cnpj.isValid(cnpjInput)
}